export enum VisitStatuses {
  scheduled = "scheduled",
  en_route = "en_route",
  arrived = "arrived",
  in_progress = "in_progress",
  completed = "complete",
  canceled = "canceled",
}

export const StatusBgColors = {
  // scheduled: "rgb(209, 250, 229)", // Light green
  scheduled: '#B2EFB7', 
  en_route: '#11926A',
  // en_route: "rgb(56, 142, 60)", // Darker green
  // arrived: "rgb(260, 195, 240)", // Light pink
  arrived: '#FAE8FF', // Light pink
  // in_progress: "rgb(240, 210, 250)", // Light purple
  in_progress: '#EDE9FE', // Light purple
  // completed: "rgb(200, 222, 251)", // Light blue
  completed: '#B2E6FF', // Light blue
  // canceled: "rgb(255, 199, 178)", // Peach
  canceled: '#FFC7B2', // Peach
};


export const StatusBgColorsDark = {
  scheduled: "rgb(0, 56, 39)", // Dark green
  en_route: "rgb(209, 250, 229)", // Light green
  arrived: "rgb(210, 100, 120)", // Dark pink
  in_progress: "rgb(150, 50, 150)", // Dark purple
  completed: "rgb(50, 100, 200)", // Dark blue
  canceled: "rgb(160, 105, 90)", // Dark peach
};

type CalendarItem = {
  startTime: string | Date,
  endTime: string | Date,
}
const toDate = (d: string | Date) => new Date(d);

export const hasOverlap = (item: CalendarItem, container: CalendarItem) => {
  return toDate(item.startTime) < toDate(container.endTime) && toDate(item.endTime) > toDate(container.startTime)
}

export const containedWithin = (item: CalendarItem, container: CalendarItem) => {
  return toDate(item.startTime) >= toDate(container.startTime) && toDate(item.endTime) <= toDate(container.endTime)
}


export type VisitResourceStatusSource = {
  errandStatus?: string | null;
  visit: { eventStatus: string };
};

/**
 * Effective calendar status for a visit resource.
 * Errands use errandStatus; when the visit is canceled and the errand is still
 * scheduled, surface canceled so the resource disappears with the visit.
 * Non-errand resources inherit the visit eventStatus.
 */
export const visitResourceStatus = (resource: VisitResourceStatusSource): string => {
  if (resource.visit.eventStatus === VisitStatuses.canceled && resource.errandStatus === VisitStatuses.scheduled) {
    return VisitStatuses.canceled;
  }
  return resource.errandStatus ?? resource.visit.eventStatus;
};
